import Center from "../../assets/images/product/facadeSilicone/center.webp";
import Left from "../../assets/images/product/facadeSilicone/left.webp";
import FacadeSilicone from "../../assets/images/products/facadeSilicone.webp";
import { categoriesOfPaints } from "../categoryOfPaints";

export const facadeSilicone = {
  category: [categoriesOfPaints.facade],
  path: "festek_facade_silicone",
  name: "FESTEK-FACADE SILICONE",
  header: "Краска фасадная акриловая «FESTEK-FACADE SILICONE»",
  link: "https://drive.google.com/file/d/1OOjwQYmKVVB8JrpXOkibNYavKm3FqZDw/view?usp=sharing",
  purchase: [
    {
      price: "165,00",
      amount: "15 кг",
    },
  ],
  productsPage: {
    title: "Фасадная «FESTEK-FACADE SILICONE»",
    text: "Силиконовая краска с водоотталкивающими свойствами для самоочищения и высокой адгезией для чистого фасада",
  },
  images: {
    products: FacadeSilicone,
    product: [Center, Left],
  },
  documentation: {
    description: {
      concept: {
        value:
          "это силиконовая краска, которая предназначена для высококачественных ответственных фасадных работ и окраски систем теплоизоляции. Окрашенные поверхности внутри помещений устойчивы к влажной уборке. Благодаря силикону, образуемое покрытие обладает максимальными водоотталкивающими свойствами и минимальным грязеудержанием, что позволяет быть вашему фасаду всегда чистым от пыли и грязи. Разработана в соответствии с требованиями к современным системам утепления зданий.",
        label: "FESTEK «FAСADE SILICONE»",
      },

      properties: {
        value: [
          "Образует «дышащее» покрытие с низким водопоглощением.",
          "Высокая адгезия к основанию и укрывистость.",
          "Обладает высокой светостойкостью.",
          "Образованное покрытие устойчиво к разрушающему воздействию атмосферных осадков, перепадов температур.",
          "Максимальные водоотталкивающие свойства и минимальным грязеудержание.",
          "Имеет насыщенный белый оттенок.",
        ],
        label: "Преимущество",
        note: [
          "*Прогнозируемый срок службы покрытия при соблюдении технологии нанесения в комплексе с грунтовками – не менее 10 лет.",
        ],
      },

      consumption: {
        value:
          "На двухслойное покрытие – 350 - 400 г/м2. Зависит от пористости поверхности, применяемого оборудования, квалификации персонала, погодных условий. При окрашивании фактурных поверхностей (типа: шуба, барашек, короед и т.п.) расход краски увеличивается в 1,5 раза.",
        label: "Расход",
      },

      package: {
        value: "11 литров – 15 килограмм; 20 литров – 25 килограмм.",
        label: "Упаковка",
      },

      suitableSubstrates: {
        value:
          "Системы теплоизоляции, бетонные, железобетонные, кирпичные, оштукатуренные и другие минеральные поверхности. Допускается применять для окрашивания железобетонных конструкций мостов, эксплуатируемых в не агрессивных и слабо агрессивных средах",
        label: "Пригодные подложки",
      },

      coatingSystem: {
        value:
          "Для получения качественного покрытия и снижения расхода краски поверхность обработать грунтовкой «Festek-Grunt» для глубокого проникновения или «Festek-MaxiGrunt», исходя из рекомендаций по применению. Краска готова к применению. При необходимости допускается разбавление водой – не более 5 %, при безвоздушном нанесении - около 10 %",
        label: "Система покрытия",
      },

      colorSolutions: {
        value:
          "Белый + цвета по большинству колеровочных системы. Возможен подбор цвета по вашему образцу. Богатую палитру цветов можете выбрать у нас сайте",
        label: "Цветовые решения",
      },
    },

    applicationTechnology: {
      composition: {
        value:
          "Водные дисперсии акриловых и силиконовых сополимеров, пигменты, наполнители, функциональные добавки, вода.",
        label: "Состав",
      },

      preparationSurfaces: {
        value:
          "Перед применением поверхность очистить от пыли, грязи, разделительных жидкостей, меловых, известковых, непрочно держащихся и несовместимых покрытий (силикатные, масляные и др. ЛКМ). При наличии биопоражений и высолов, удалить их механически или при помощи моек высокого давления, и при необходимости обработать специальными составами. Новые бетонные поверхности грунтовать не ранее, чем через 28 дней, оштукатуренные – не ранее, чем через 7 дней (в соответствии с рекомендациями производителя).",
        label: "Подготовка поверхности",
      },

      methodAndConditionsDrawing: {
        value:
          "Работы проводить при температуре окружающего воздуха, краски и окрашиваемой поверхности не ниже 10 °С и не выше 25 °С. Не допускается нанесение при неблагоприятных погодных условиях (дождь, туман, выпадение росы, сильный ветер более 10 м/с). Не наносить краску на сильно нагретую поверхность, находящуюся под прямыми солнечными лучами. При проведении окрасочных работ влажность основания должна быть не более 8 %, влажность воздуха – не более 80 %. Краска готова к применению. При необходимости допускается разбавление водой – не более 5 %, при безвоздушном нанесении - около 10 %. Перед применением краску тщательно перемешать и наносить на поверхность: •\u00A0Кистью; •\u00A0Валиком; •\u00A0Пневматическим или безвоздушным методом распыления; Упаковку с частично использованным материалом тщательно закрыть, а ее содержимое использовать в наиболее короткий срок. Краска одного цвета, но различных партий может незначительно отличаться по тону. Для исключения разнооттеночности получаемого покрытия следует выбирать краску одной партии или смешивать необходимое количество материала различных партий в отдельной емкости. После работы инструмент, пятна отмыть теплой водой с мылом до высыхания краски.",
        label: "Способ и условия нанесения",
      },

      temperature: {
        value:
          "Промежуточная сушка каждого слоя в течение 4 ч при температуре (20 ± 2) °С. При более низкой температуре и (или) повышенной влажности время высыхания может увеличиваться до 24 ч.",
        label: "Температурный режим, время высыхания",
      },

      endlessApplication: {
        value:
          'При нанесении краскопультом (безвоздушное) рекомендуются след. параметры: угол распыления 60°, диаметр сопла 0,53-0,58 мм (0,021"-0,023" дюйма), Давление 175-180 bar.',
        label: "Безвоздушное нанесение",
      },
    },

    technicalData: [
      {
        qualityIndicators: "Массовая доля нелетучих веществ, %",
        value: "56 - 64",
      },
      {
        qualityIndicators: "Показатель концентрации ионов водорода, рН",
        value: "7,5 - 9,5",
      },
      { qualityIndicators: "Степень перетира, мкм, не более", value: "70" },
      {
        qualityIndicators:
          "Время высыхания до степени 3 при температуре (20 ± 2) °С, ч, не более",
        value: "1",
      },
      {
        qualityIndicators:
          "Условная светостойкость покрытия за 24 ч (изменение коэффициента диффузного отражения), %, не более",
        value: "5",
      },
      {
        qualityIndicators: "Адгезия покрытия к основанию, МПа, не менее",
        value: "2,0",
      },
      {
        qualityIndicators:
          "Стойкость покрытия к статическому воздействию воды при температуре (20 ± 2) °С, ч, не менее",
        value: "24",
      },
      {
        qualityIndicators:
          "Стойкость покрытия при температуре (20 ± 2) °С к статическому воздействию дезинфицирующих растворов, мин, не менее",
        value: "",
      },
      {
        qualityIndicators: "- «Гексадекон»",
        value: "30",
      },
      {
        qualityIndicators: "- «Полидез»",
        value: "30",
      },
      {
        qualityIndicators: "- «Дескоцид»",
        value: "30",
      },
      {
        qualityIndicators: "- «Триацид»",
        value: "60",
      },
      { qualityIndicators: "- «КДИ»", value: "120" },
      {
        qualityIndicators:
          "Коэффициент паропроницаемости, мг/(м ч Па), не менее",
        value: "0,020",
      },
      {
        qualityIndicators: "Морозостойкость покрытия, циклы, не менее",
        value: "50",
      },
      {
        qualityIndicators:
          "Стойкость покрытия к воздействию климатических факторов, циклы, не менее",
        value: "120",
      },
      {
        qualityIndicators:
          "Срок службы покрытия в условиях эксплуатации У1, лет, не менее",
        value: "10",
      },
    ],
  },
};
